// Tech icons small size
import html from "../assets/icons_logos/icons8-html-5-48.png";
import css from "../assets/icons_logos/icons8-css-48.png";
import javascript from "../assets/icons_logos/icons8-javascript-48.png";
import reactjs from "../assets/icons_logos/icons8-react-48.png";
import nodejs from "../assets/icons_logos/icons8-nodejs-48.png";
import express from "../assets/icons_logos/icons8-express-js-50.png";
import mongodb from "../assets/icons_logos/icons8-mongodb-48.png";
import tailwind from "../assets/icons_logos/icons8-tailwind-css-48.png";
import sass from "../assets/icons_logos/icons8-sass-48.png";
import gcp from "../assets/icons_logos/icons8-google-cloud-48.png";
import mui from "../assets/icons_logos/icons8-material-ui-48.png";
import git from "../assets/icons_logos/icons8-git-48.png";
import adobe_ai from "../assets/icons_logos/icons8-adobe-illustrator-48.png";
import aws_light from "../assets/icons_logos/aws_white.png";
import bootstrap from "../assets/icons_logos/icons8-bootstrap-48.png";
//Tech icons large size
import javascript_large from "../assets/images/javascript.png";
import css_large from "../assets/images/icons8-css-256.png";
import html_large from "../assets/images/html.png";
import tailwind_large from "../assets/images/tailwind-css.png";
import bootstrap_large from "../assets/images/icons8-bootstrap-256.png";
import sass_large from "../assets/images/icons8-sass-256.png";
import mui_large from "../assets/images/icons8-material-ui-256.png";
import nodejs_large from "../assets/images/nodejs.png";
import expressdark_large from "../assets/images/icons8-express-js-256.png";
import mongodb_large from "../assets/images/mongodb (1).png";
import git_large from "../assets/images/git.png";
import postman_large from "../assets/icons_logos/postman_256.png";
import gcp_large from "../assets/images/icons8-google-cloud-256.png";
import aws_large from "../assets/images/icons8-aws-256.png";
import adobe_large from "../assets/images/adobe-illustrator.png";
import reactlogo from "../assets/images/react.png";
import nextJs from "../assets/images/icons8-nextjs-96.png"
import typescript from "../assets/images/icons8-typescript-256.png"
//company logos
import novatales from "../assets/icons_logos/novatales.png"
import naresh from "../assets/icons_logos/naresh-it-logo2.png"
// projects images

//Livvon Customer 
import livvon_customer from "../assets/images/livvon.webp"
import liv_cust_1 from "../assets/images/liv-cust/_liv_cust_1_converted.webp";
import liv_cust_2 from "../assets/images/liv-cust/_liv_cust_2_converted.webp";
import liv_cust_3 from "../assets/images/liv-cust/_liv_cust_3_converted.webp";
import liv_cust_4 from "../assets/images/liv-cust/_liv_cust_4_converted.webp";
import liv_cust_5 from "../assets/images/liv-cust/_liv_cust_5_converted.webp";
import liv_cust_6 from "../assets/images/liv-cust/_liv_cust_6_converted.webp";
import liv_cust_7 from "../assets/images/liv-cust/_liv_cust_7_converted.webp";
import liv_cust_8 from "../assets/images/liv-cust/_liv_cust_8_converted.webp";
import liv_cust_9 from "../assets/images/liv-cust/_liv_cust_9_converted.webp";
import liv_cust_10 from "../assets/images/liv-cust/_liv_cust_10_converted.webp";
import liv_cust_11 from "../assets/images/liv-cust/_liv_cust_11_converted.webp";
import liv_cust_12 from "../assets/images/liv-cust/_liv_cust_12_converted.webp";
import liv_cust_13 from "../assets/images/liv-cust/_liv_cust_13_converted.webp";
import liv_cust_14 from "../assets/images/liv-cust/_liv_cust_14_converted.webp";
import liv_cust_15 from "../assets/images/liv-cust/_liv_cust_15_converted.webp";
import liv_cust_16 from "../assets/images/liv-cust/_liv_cust_16_converted.webp";
import liv_cust_17 from "../assets/images/liv-cust/_liv_cust_17_converted.webp";
import liv_cust_18 from "../assets/images/liv-cust/_liv_cust_18_converted.webp";
import liv_cust_19 from "../assets/images/liv-cust/_liv_cust_19_converted.webp";
import liv_cust_20 from "../assets/images/liv-cust/_liv_cust_20_converted.webp";

//Livvon Admin
import livvon_admin from "../assets/images/livvon_admin.webp"
import liv_adm_1 from "../assets/images/liv-admin/_liv_adm_1_converted.webp";
import liv_adm_2 from "../assets/images/liv-admin/_liv_adm_2_converted.webp";
import liv_adm_3 from "../assets/images/liv-admin/_liv_adm_3_converted.webp";
import liv_adm_4 from "../assets/images/liv-admin/_liv_adm_4_converted.webp";
import liv_adm_5 from "../assets/images/liv-admin/_liv_adm_5_converted.webp";
import liv_adm_6 from "../assets/images/liv-admin/_liv_adm_6_converted.webp";
import liv_adm_7 from "../assets/images/liv-admin/_liv_adm_7_converted.webp";
import liv_adm_8 from "../assets/images/liv-admin/_liv_adm_8_converted.webp";
import liv_adm_9 from "../assets/images/liv-admin/_liv_adm_9_converted.webp";
import liv_adm_10 from "../assets/images/liv-admin/_liv_adm_10_converted.webp";
import liv_adm_11 from "../assets/images/liv-admin/_liv_adm_11_converted.webp";
import liv_adm_12 from "../assets/images/liv-admin/_liv_adm_12_converted.webp";
import liv_adm_13 from "../assets/images/liv-admin/_liv_adm_13_converted.webp";
import liv_adm_14 from "../assets/images/liv-admin/_liv_adm_14_converted.webp";
import liv_adm_15 from "../assets/images/liv-admin/_liv_adm_15_converted.webp";
import liv_adm_16 from "../assets/images/liv-admin/_liv_adm_16_converted.webp";
//MagnAid 
import magnaid from "../assets/images/magnaid.webp"
import magnaid_1 from "../assets/images/magnaid/magnaid_1_converted.webp";
import magnaid_2 from "../assets/images/magnaid/magnaid_2_converted.webp";
import magnaid_3 from "../assets/images/magnaid/magnaid_3_converted.webp";
import magnaid_4 from "../assets/images/magnaid/magnaid_4_converted.webp";
import magnaid_5 from "../assets/images/magnaid/magnaid_5_converted.webp";
import magnaid_6 from "../assets/images/magnaid/magnaid_6_converted.webp";
import magnaid_7 from "../assets/images/magnaid/magnaid_7_converted.webp";
import magnaid_8 from "../assets/images/magnaid/magnaid_8_converted.webp";
import magnaid_9 from "../assets/images/magnaid/magnaid_9_converted.webp";
import magnaid_10 from "../assets/images/magnaid/magnaid_10_converted.webp";
import magnaid_11 from "../assets/images/magnaid/magnaid_11_converted.webp";
import magnaid_12 from "../assets/images/magnaid/magnaid_12_converted.webp";
import magnaid_13 from "../assets/images/magnaid/magnaid_13_converted.webp";
import magnaid_14 from "../assets/images/magnaid/magnaid_14_converted.webp";
import magnaid_15 from "../assets/images/magnaid/magnaid_15_converted.webp";
import magnaid_16 from "../assets/images/magnaid/magnaid_16_converted.webp";
import magnaid_17 from "../assets/images/magnaid/magnaid_17_converted.webp";
import magnaid_18 from "../assets/images/magnaid/magnaid_18_converted.webp";
import magnaid_19 from "../assets/images/magnaid/magnaid_19_converted.webp";
import magnaid_20 from "../assets/images/magnaid/magnaid_20_converted.webp";

//Conceiva 
import conceiva from "../assets/images/conceiva.webp"
import conc_1 from "../assets/images/conceiva/conceiva_1_converted.webp";
import conc_2 from "../assets/images/conceiva/conceiva_2_converted.webp";
import conc_3 from "../assets/images/conceiva/conceiva_3_converted.webp";
import conc_4 from "../assets/images/conceiva/conceiva_4_converted.webp";
import conc_5 from "../assets/images/conceiva/conceiva_5_converted.webp";
import conc_6 from "../assets/images/conceiva/conceiva_6_converted.webp";
import conc_7 from "../assets/images/conceiva/conceiva_7_converted.webp";
import conc_8 from "../assets/images/conceiva/conceiva_8_converted.webp";
import conc_9 from "../assets/images/conceiva/conceiva_9_converted.webp";
import conc_10 from "../assets/images/conceiva/conceiva_10_converted.webp";
import conc_11 from "../assets/images/conceiva/conceiva_11_converted.webp";
import conc_12 from "../assets/images/conceiva/conceiva_12_converted.webp";
import conc_13 from "../assets/images/conceiva/conceiva_13_converted.webp";
import conc_14 from "../assets/images/conceiva/conceiva_14_converted.webp";
import conc_15 from "../assets/images/conceiva/conceiva_15_converted.webp";
import conc_16 from "../assets/images/conceiva/conceiva_16_converted.webp";
import conc_17 from "../assets/images/conceiva/conceiva_17_converted.webp";

// Dr Appointment Booking WebApp Custoer
import dr_web_cust_1 from "../assets/images/DrWebApp/dr_app_1_converted.webp";
import dr_web_cust_2 from "../assets/images/DrWebApp/dr_app_2_converted.webp";
import dr_web_cust_3 from "../assets/images/DrWebApp/dr_app_3_converted.webp";
import dr_web_cust_4 from "../assets/images/DrWebApp/dr_app_4_converted.webp";
import dr_web_cust_5 from "../assets/images/DrWebApp/dr_app_5_converted.webp";
import dr_web_cust_6 from "../assets/images/DrWebApp/dr_app_6_converted.webp";
import dr_web_cust_7 from "../assets/images/DrWebApp/dr_app_7_converted.webp";
import dr_web_cust_8 from "../assets/images/DrWebApp/dr_app_8_converted.webp";
import dr_web_cust_9 from "../assets/images/DrWebApp/dr_app_9_converted.webp";
import dr_web_cust_10 from "../assets/images/DrWebApp/dr_app_10_converted.webp";
import dr_web_cust_11 from "../assets/images/DrWebApp/dr_app_11_converted.webp";
import dr_web_cust_12 from "../assets/images/DrWebApp/dr_app_12_converted.webp";
import dr_web_cust_13 from "../assets/images/DrWebApp/dr_app_13_converted.webp";
import dr_web_cust_14 from "../assets/images/DrWebApp/dr_app_14_converted.webp";
import dr_web_cust_15 from "../assets/images/DrWebApp/dr_app_15_converted.webp";
import dr_web_cust_16 from "../assets/images/DrWebApp/dr_app_16_converted.webp";
import dr_web_cust_17 from "../assets/images/DrWebApp/dr_app_17_converted.webp";

// Dr Appointment Booking WebApp Admin and Doctors
import dr_web_admin_1 from "../assets/images/DrWebAdmin/dr_web_adm_1_converted.webp";
import dr_web_admin_2 from "../assets/images/DrWebAdmin/dr_web_adm_2_converted.webp";
import dr_web_admin_3 from "../assets/images/DrWebAdmin/dr_web_adm_3_converted.webp";
import dr_web_admin_4 from "../assets/images/DrWebAdmin/dr_web_adm_4_converted.webp";
import dr_web_admin_5 from "../assets/images/DrWebAdmin/dr_web_adm_5_converted.webp";
import dr_web_admin_6 from "../assets/images/DrWebAdmin/dr_web_adm_6_converted.webp";
import dr_web_admin_7 from "../assets/images/DrWebAdmin/dr_web_adm_7_converted.webp";
import dr_web_admin_8 from "../assets/images/DrWebAdmin/dr_web_adm_8_converted.webp";
import dr_web_admin_9 from "../assets/images/DrWebAdmin/dr_web_adm_9_converted.webp";
import dr_web_admin_10 from "../assets/images/DrWebAdmin/dr_web_adm_10_converted.webp";



// Synk Web Chat Application

import synk_chat_1 from "../assets/images/synkchat/synk_chat_1.webp";
import synk_chat_2 from "../assets/images/synkchat/synk_chat_2.webp";
import synk_chat_3 from "../assets/images/synkchat/synk_chat_3.webp";
import synk_chat_4 from "../assets/images/synkchat/synk_chat_4.webp";
import synk_chat_5 from "../assets/images/synkchat/synk_chat_5.webp";
import synk_chat_6 from "../assets/images/synkchat/synk_chat_6.webp";
import synk_chat_7 from "../assets/images/synkchat/synk_chat_7.webp";
import synk_chat_8 from "../assets/images/synkchat/synk_chat_8.webp";
import synk_chat_9 from "../assets/images/synkchat/synk_chat_9.webp";
import synk_chat_10 from "../assets/images/synkchat/synk_chat_10.webp";
import synk_chat_11 from "../assets/images/synkchat/synk_chat_11.webp";
import synk_chat_12 from "../assets/images/synkchat/synk_chat_12.webp";
import synk_chat_13 from "../assets/images/synkchat/synk_chat_13.webp";
import synk_chat_14 from "../assets/images/synkchat/synk_chat_14.webp";
import synk_chat_15 from "../assets/images/synkchat/synk_chat_15.webp";
import synk_chat_16 from "../assets/images/synkchat/synk_chat_16.webp";
import synk_chat_17 from "../assets/images/synkchat/synk_chat_17.webp";
import synk_chat_18 from "../assets/images/synkchat/synk_chat_18.webp";
import synk_chat_19 from "../assets/images/synkchat/synk_chat_19.webp";
import synk_chat_20 from "../assets/images/synkchat/synk_chat_20.webp";
import synk_chat_21 from "../assets/images/synkchat/synk_chat_21.webp";
import synk_chat_22 from "../assets/images/synkchat/synk_chat_22.webp";
import synk_chat_23 from "../assets/images/synkchat/synk_chat_23.webp";
import synk_chat_24 from "../assets/images/synkchat/synk_chat_24.webp";
import synk_chat_25 from "../assets/images/synkchat/synk_chat_25.webp";


const portfolioData = [
    // Skills Data and icons
    {
        id: 0,
        title: "Skills",
        icons: [
            {
                name: "HTML5",
                iconsmall: html,
                iconlarge: html_large,
                category: "frontend",
            },
            {
                name: "CSS3",
                iconsmall: css,
                iconlarge: css_large,
                category: "frontend",
            },
            {
                name: "JavaScript",
                iconsmall: javascript,
                iconlarge: javascript_large,
                category: "frontend",
            },
            {
                name: "React JS",
                iconsmall: reactjs,
                iconlarge: reactlogo,
                category: "frontend",
            },
            {
                name: "Node.js",
                iconsmall: nodejs,
                iconlarge: nodejs_large,
                category: "backend",
            },
            {
                name: "Express.js",
                iconsmall: express,
                iconlarge: expressdark_large,
                category: "backend",
            },

            {
                name: "MongoDB",
                iconsmall: mongodb,
                iconlarge: mongodb_large,
                category: "backend",
            },
            {
                name: "Tailwind CSS",
                iconsmall: tailwind,
                iconlarge: tailwind_large,
                category: "frontend",
            },
            {
                name: "Sass",
                iconsmall: sass,
                iconlarge: sass_large,
                category: "frontend",
            },
            {
                name: "Material UI",
                iconsmall: mui,
                iconlarge: mui_large,
                category: "frontend",
            },
            {
                name: "Bootstrap",
                iconsmall: bootstrap,
                iconlarge: bootstrap_large,
                category: "frontend",
            },
            {
                name: "Git",
                iconsmall: git,
                iconlarge: git_large,
                category: "backend",
            },

            {
                name: "Postman",
                iconsmall: postman_large,
                iconlarge: postman_large,
                category: "tools",
            },
            {
                name: "Google Cloud",
                iconsmall: gcp,
                iconlarge: gcp_large,
                category: "tools",
            },
            {
                name: "AWS",
                iconsmall: aws_light,
                iconlarge: aws_large,
                category: "tools",
            },

            {
                name: "Illustrator",
                iconsmall: adobe_ai,
                iconlarge: adobe_large,
                category: "tools",
            },
            {
                name: "NextJs",
                iconsmall: nextJs,
                iconlarge: nextJs,
                category: "learning"
            },
            {
                name: "React Native",
                iconsmall: reactjs,
                iconlarge: reactlogo,
                category: "learning"
            },
            {
                name: "TypeScript",
                iconsmall: typescript,
                iconlarge: typescript,
                category: "learning"
            },
        ],
    },
    {
        id: 1,
        title: "Home Page Data",

        data: [
            //About Me Data Home Page
            {
                id: 11,
                title: "About Me",
                aboutme: {
                    company: "NovaTales Media LLP",
                    role: "Frontend Developer",
                    duration: "November 2024 – Present",
                    description:
                        "I’m a passionate Frontend Developer with hands-on experience in building responsive and dynamic web applications. Skilled in React, JavaScript, and modern UI/UX practices, I love transforming ideas into smooth digital experiences.",
                    descriptiontwo:
                        "Beyond coding, I'm always curious about learning and believe in building products that not only work but also connect with people. I value teamwork and love exploring new technologies.",
                    location: "Hyderabad, Telangana",
                    locationlink: "",
                    companyLink: "https://novatales.com/",
                },
            },

            // Projects in Home Page
            {
                id: 12,
                title: "Projects",
                projects: [
                    {
                        projectType: "Personal Porject",
                        projectId: 121,
                        projectName: "Synk Chat App",
                        projectDesc:
                            "A real-time, full-stack chat application enabling instant, persistent, one-on-one, and group communication between users. Includes secure authentication and an intuitive user interface.",
                        projectStacks: [
                            "ReactJS",
                            "NodeJS",
                            "Material UI",
                            "MongoDB",
                            "Express.js",
                            "Tailwind CSS",
                            "DaisyUI",
                            "Socket.io"
                        ],
                        projectLink: "https://synk-chat-five.vercel.app/",
                        projectCaseStudyLink: "/projects/case-study/synk-chat-app",
                        myContribution: [
                            "Engineered secure real-time messaging with Socket.IO",
                            "Developed JWT authentication for protected user sessions",
                            "Built responsive chat UI using React",
                            "Implemented scalable data persistence with MongoDB",
                        ],
                    },
                    {
                        projectId: 122, projectType: "Personal Porject",
                        projectName: "Dr. Booking Web App",
                        projectDesc:
                            "A platform where patients can register, book appointments, make payments, and users/doctors/admin can manage appointments and profiles.",
                        projectStacks: [
                            "ReactJS",
                            "NodeJS",
                            "Material UI",
                            "MongoDB",
                            "Tailwind CSS",
                        ],
                        projectLink: "https://drbookwebapp-frontend.onrender.com/",
                        projectCaseStudyLink: "/projects/case-study/dr-appointment-webapp",
                        myContribution: [
                            "Designed responsive UI with React & Tailwind CSS",
                            "Integrated JWT-based user, doctor & admin login", "Developed admin panel for managing doctors & users",
                            `Enabled patients to easily register, and book appointments.`,
                        ],
                    },
                ],
            },
        ],
    },
    //Home Page Data completed

    // About Page Data

    {
        id: 2,
        title: "About Page Data",
        data:
        {
            profile: {
                pic: "",
                aboutmeparagraph:
                    "Currently, I'm a Frontend developer with 1+ year of experience building responsive, high-performance web apps.",
                description:
                    "I'm Himanshu, a professionally trained MERN stack developer with hands-on experience in React JS and modern web technologies. I specialize in creating scalable, user-friendly interfaces and love building digital products that solve real problems. With 1+ year of professional experience, I thrive in dynamic environments and enjoy collaborating with teams to bring ideas to life.",
                hobbies: [
                    "Reading books – especially tech & self-growth related",
                    "Listening to music & exploring new genres",
                    "Staying updated on global trends & innovations",
                    "Engaging in political talks & discussions to explore diverse perspectives",
                ],
                strength: [
                    "Quick learner & adaptive",
                    "Problem-solving mindset",
                    "Detail-oriented UI design approach",
                    "Strong foundation in React & JavaScript",
                ],
            },
            experience: [
                {
                    id: 1,
                    company: "NovaTales Media LLP",
                    role: "Frontend Developer",
                    logo: novatales,
                    location: "Hyderabad, Telangana",
                    duration: "November 2024 – Present",
                    description:
                        "As a Frontend Developer, I took ownership of crafting engaging and high-performing user interfaces that not only aligned with brand goals but also elevated the overall digital experience. My role involved building reusable UI components, optimizing performance, collaborating cross-functionally with design and marketing teams, and ensuring seamless integration of campaigns into web platforms. Beyond just coding screens, I focused on delivering user-centric, accessible, and scalable solutions that directly impacted engagement and retention.",
                    responsibilities: [
                        "Developed responsive and interactive UI components using React, ensuring smooth cross-device compatibility",
                        "Enhanced site performance and accessibility, improving engagement and user retention",
                        "Implemented API integrations and optimized state management for seamless data flow",
                        "Contributed to backend development, building and refining RESTful APIs in Node.js",
                        "Worked on database operations (MongoDB) for secure storage, queries, and data consistency",
                        "Collaborated with design and marketing teams to deliver scalable, campaign-ready features",
                    ],
                    locationlink: "",
                    companyLink: "https://novatales.com/",
                },
            ],
            certificate: [
                {
                    id: 1,
                    company: "Naresh IT",
                    role: "UI Full Stack With ReactJS",
                    logo: naresh,
                    location: "Hyderabad, Telangana",
                    duration: "April - August 2024",
                    description:
                        "As a trainee in UI Full Stack with ReactJS, I worked on building responsive web applications using the MERN stack. My role involved developing reusable UI components, implementing APIs, managing databases, and enhancing overall performance and scalability of applications.",
                    responsibilities: [
                        "Developed responsive and interactive UI components with ReactJS for cross-device compatibility",
                        "Implemented RESTful APIs using Node.js and Express.js for backend communication",
                        "Designed and managed MongoDB databases for secure data handling",
                        "Enhanced site performance and optimized state management for seamless user experience",
                        "Collaborated on projects simulating real-world applications using Git & GitHub",
                        "Performed thorough testing and debugging to ensure application reliability and functionality",
                    ],
                    locationlink: "",
                    companyLink: "https://novatales.com/",
                    certificateName: "UI Full Stack With React",
                    certificateLink: "https://www.linkedin.com/in/himanshumishra17/overlay/1753120822194/single-media-viewer/?profileId=ACoAAEkM3QcBjPvIjOKMhGc660O63MHWeinwVuM"
                },
            ],
        },

    },

    // About Page data completed 

    // Project Page Data and case study pages
    {
        id: 3,
        title: "Projects Page Data",
        data: [
            // Project 
            {
                category: "Professional",
                tag: "in progress",
                slug: "livvon-customer-portal",
                techUsed: ["MongoDB", "ExpressJS", "ReactJS", "NodeJS", "Tailwind CSS", "Material UI", "AWS", "SCSS"],
                header: {
                    title: "Livvon Comforts – E-Commerce Web Application",
                    description: "Livvon Comforts is a modern e-commerce web application designed to provide customers with a seamless shopping experience for mattresses, pillows, and related comfort products. Inspired by leading platforms like Amazon and Flipkart, the project focuses on delivering a clean, reliable, and user-friendly interface where customers can explore, purchase, and manage their comfort essentials with ease.",
                    duration: "Navember 2024 - May-2025",
                    role: "Frontend Developer",
                },
                context: {
                    title: "Problem Statement / Intention",
                    goals: [
                        "Eliminate unnecessary steps in the shopping journey.",
                        "Simplify the interface to avoid confusion and save time.",
                        "Provide a hassle-free shopping experience.",
                        "Enable customers to book products in a straightforward way.",
                        "Deliver a clean experience with no distractions or 'hocus-pocus'."
                    ]
                },
                process: {
                    title: "Process",
                    challenge: [
                        "Maintaining consistency across the UI while scaling the project.",
                        "Raw CSS made the codebase hard to manage and less reusable.",
                        "Product filtering experience was clunky and slow."
                    ],

                },
                myContribution: {
                    title: "My Contribution",
                    myrole: [
                        "Migrated the UI from raw CSS to Tailwind CSS for scalable and maintainable design.",
                        "Standardized design tokens and improved responsiveness across pages.",
                        "Implemented dynamic category-based product filtering in React.",
                        "Enhanced overall user experience by simplifying browsing and checkout flow."
                    ]
                },
                outcomes: {
                    title: "Outcomes",
                    results: [
                        "Delivered a modern, responsive, and scalable UI.",
                        "Improved product discovery with category-based filtering.",
                        "Simplified the shopping journey for customers.",
                        "Enhanced performance and design consistency across the app.",
                        "Gained hands-on experience in migrating large projects to Tailwind CSS."
                    ]
                },

                visualgallery: {
                    title: "Visual Gallery",
                    screenShots: [
                        {
                            title: "",
                            image: liv_cust_1,
                        },
                        {
                            title: "",
                            image: liv_cust_2,
                        },
                        {
                            title: "",
                            image: liv_cust_3,
                        },
                        {
                            title: "",
                            image: liv_cust_4,
                        },
                        {
                            title: "",
                            image: liv_cust_5,
                        },
                        {
                            title: "",
                            image: liv_cust_6,
                        },
                        {
                            title: "",
                            image: liv_cust_7,
                        },
                        {
                            title: "",
                            image: liv_cust_8,
                        },
                        {
                            title: "",
                            image: liv_cust_9,
                        },
                        {
                            title: "",
                            image: liv_cust_10,
                        },
                        {
                            title: "",
                            image: liv_cust_11,
                        },
                        {
                            title: "",
                            image: liv_cust_12,
                        },
                        {
                            title: "",
                            image: liv_cust_13,
                        },
                        {
                            title: "",
                            image: liv_cust_14,
                        },
                        {
                            title: "",
                            image: liv_cust_15,
                        },
                        {
                            title: "",
                            image: liv_cust_16,
                        },
                        {
                            title: "",
                            image: liv_cust_17,
                        },
                        {
                            title: "",
                            image: liv_cust_18,
                        },
                        {
                            title: "",
                            image: liv_cust_19,
                        },
                        {
                            title: "",
                            image: liv_cust_20,
                        },
                    ],
                },
                navigation: {
                    demo: "https://livoncustomer-dev.novatales.com/",
                    repo: ""
                },
                image: livvon_customer,
                text: " Livvon Customer Panel",
            },
            {
                category: "Professional",
                tag: "in progress",
                slug: "livvon-admin-portal",
                techUsed: ["React", "Tailwind CSS", "Context API", "Node.js", "Express", "MongoDB", "JWT", "OTP Authentication"],
                header: {
                    title: "Livvon Admin Portal – Centralized Management System",
                    description: "The Livvon Admin Portal is a centralized application built to manage the Livvon Customer Platform. It provides administrators with powerful tools to maintain products, track orders, and manage customer data efficiently. Alongside these core operations, the portal also features secure OTP-based login and a role-based access system (Superadmin, Admin, Member) to ensure structured control and smooth collaboration within the team.",
                    duration: "April 2025 - July 2025",
                    role: "Full-Stack Developer",
                },
                context: {
                    title: "Problem Statement / Intention",
                    goals: [
                        "Provide a secure authentication system with OTP-based login and registration.",
                        "Enable admins to manage customers, orders, products, and admin accounts seamlessly.",
                        "Implement role-based access with three levels – Superadmin, Admin, and Member.",
                        "Ensure data consistency and control while giving all roles visibility into system operations.",
                        "Create a centralized admin portal to simplify backend management of the customer platform."
                    ]
                },
                process: {
                    title: "Process",
                    challenge: [
                        "Designing a scalable role-based access system with clear boundaries between Superadmin, Admin, and Member.",
                        "Integrating OTP verification for secure login and registration.",
                        "Handling CRUD operations for products, orders, and customer data with real-time updates.",
                        "Ensuring smooth user experience while managing large datasets across different modules.",
                        "Maintaining security while allowing multiple levels of access to the same data."
                    ],
                },
                myContribution: {
                    title: "My Contribution",
                    myrole: [
                        "Designed and implemented OTP-based login and registration system for secure access.",
                        "Developed role-based authentication and authorization (Superadmin / Admin / Member).",
                        "Built CRUD functionality for products, customers, and orders.",
                        "Implemented order details module with dynamic tracking of status and customer information.",
                        "Designed reusable UI components in React with Tailwind CSS for forms, tables, and modals.",
                        "Created admin management system where Superadmin can control Admins and Members, and Admins can control only Members.",
                    ]
                },
                outcomes: {
                    title: "Outcomes",
                    results: [
                        "Delivered a secure and functional admin portal with OTP authentication.",
                        "Implemented full role-based control ensuring data security and structured operations.",
                        "Simplified backend management with complete CRUD functionality for customers, orders, and products.",
                        "Enabled hierarchical control: Superadmin > Admin > Member with proper restrictions.",
                        "Enhanced technical skills in authentication, authorization, and role-based system design."
                    ]
                },

                visualgallery: {
                    title: "Visual Gallery",
                    screenShots: [{
                        title: "",
                        image: liv_adm_1,
                    },
                    {
                        title: "",
                        image: liv_adm_2,
                    },
                    {
                        title: "",
                        image: liv_adm_3,
                    },
                    {
                        title: "",
                        image: liv_adm_4,
                    },
                    {
                        title: "",
                        image: liv_adm_5,
                    },
                    {
                        title: "",
                        image: liv_adm_6,
                    },
                    {
                        title: "",
                        image: liv_adm_7,
                    },
                    {
                        title: "",
                        image: liv_adm_8,
                    },
                    {
                        title: "",
                        image: liv_adm_9,
                    },
                    {
                        title: "",
                        image: liv_adm_10,
                    },
                    {
                        title: "",
                        image: liv_adm_11,
                    },
                    {
                        title: "",
                        image: liv_adm_12,
                    },
                    {
                        title: "",
                        image: liv_adm_13,
                    },
                    {
                        title: "",
                        image: liv_adm_14,
                    },
                    {
                        title: "",
                        image: liv_adm_15,
                    },
                    {
                        title: "",
                        image: liv_adm_16,
                    },],
                },
                navigation: {
                    demo: "https://livoncustomer-dev.novatales.com/",
                    repo: ""
                },
                image: livvon_admin,
                text: " Livvon Admin Panel",
            },
            {
                category: "Professional",
                tag: "live",
                slug: "magaid-hospitals",
                techUsed: ["React", "Tailwind CSS", "EmailJS / Form Handling", "Material UI"],
                header: {
                    title: "MagAid Hospitals – Official Website & Appointment Booking",
                    description: "MagAid Hospitals website is a static yet fully functional platform designed to showcase the hospital’s services, share essential information, and allow patients to book appointments seamlessly. With a clean, modern, and responsive design, the website ensures visitors can easily explore hospital details, access service information, and schedule consultations using the integrated appointment form.",
                    duration: "June 2025 – August 2025",
                    role: "Frontend Developer",
                },
                context: {
                    title: "Problem Statement / Intention",
                    goals: [
                        "Provide MagAid Hospitals with a professional and trustworthy online presence.",
                        "Showcase medical services clearly for easy patient understanding.",
                        "Enable patients to book appointments through a user-friendly form.",
                        "Ensure the website is responsive, lightweight, and accessible.",
                        "Create a scalable structure for future updates and expansions."
                    ]
                },
                process: {
                    title: "Process",
                    challenge: [
                        "Designing a professional healthcare website that builds trust while staying simple to navigate.",
                        "Implementing responsive layouts for smooth experiences across devices.",
                        "Integrating an appointment booking form with validation and submission handling.",
                        "Balancing modern aesthetics with accessibility and performance requirements."
                    ],
                },
                myContribution: {
                    title: "My Contribution",
                    myrole: [
                        "Designed and developed the website using React and Tailwind CSS.",
                        "Structured pages for hospital overview, services, and contact details.",
                        "Implemented an appointment booking form with validation and EmailJS integration.",
                        "Optimized the design for responsiveness and accessibility.",
                        "Deployed the website on Vercel, ensuring high availability and smooth performance."
                    ]
                },
                outcomes: {
                    title: "Outcomes",
                    results: [
                        "Launched the official MagAid Hospitals website, now live for patients and visitors.",
                        "Delivered a seamless appointment booking experience through the online form.",
                        "Enhanced the hospital’s digital presence with a clean, professional interface.",
                        "Improved accessibility and performance for better patient engagement.",
                        "Gained hands-on experience in static site deployment and form submission workflows."
                    ]
                },
                visualgallery: {
                    title: "Visual Gallery",
                    screenShots: [{
                        title: "",
                        image: magnaid_1,
                    },
                    {
                        title: "",
                        image: magnaid_2,
                    },
                    {
                        title: "",
                        image: magnaid_3,
                    },
                    {
                        title: "",
                        image: magnaid_4,
                    },
                    {
                        title: "",
                        image: magnaid_5,
                    },
                    {
                        title: "",
                        image: magnaid_6,
                    },
                    {
                        title: "",
                        image: magnaid_7,
                    },
                    {
                        title: "",
                        image: magnaid_8,
                    },
                    {
                        title: "",
                        image: magnaid_9,
                    },
                    {
                        title: "",
                        image: magnaid_10,
                    },
                    {
                        title: "",
                        image: magnaid_11,
                    },
                    {
                        title: "",
                        image: magnaid_12,
                    },
                    {
                        title: "",
                        image: magnaid_13,
                    },
                    {
                        title: "",
                        image: magnaid_14,
                    },
                    {
                        title: "",
                        image: magnaid_15,
                    },
                    {
                        title: "",
                        image: magnaid_16,
                    },
                    {
                        title: "",
                        image: magnaid_17,
                    },
                    {
                        title: "",
                        image: magnaid_18,
                    },
                    {
                        title: "",
                        image: magnaid_19,
                    },
                    {
                        title: "",
                        image: magnaid_20,
                    },],
                },
                navigation: {
                    demo: "https://www.magnaid.com/",
                    repo: ""
                },
                image: magnaid,
                text: " MagnAid Hospitals",
            },
            {
                category: "Professional",
                tag: "live",
                slug: "conceiva-fertility",
                techUsed: ["React", "Tailwind CSS", "Material UI", "SCSS",],
                header: {
                    title: "Conceiva Fertility – Official Website & Appointment Booking",
                    description: "Conceiva Fertility website is a static, responsive platform built to showcase specialized fertility care services for both men and women. The website highlights treatments, facilities, and expertise while providing patients with a seamless way to book appointments online through an integrated form. Its clean, user-friendly design ensures patients can quickly access vital information and connect with the clinic.",
                    duration: "April 2025 - May 2025",
                    role: "Frontend Developer",
                },
                context: {
                    title: "Problem Statement / Intention",
                    goals: [
                        "Provide Conceiva Fertility with a professional digital presence to build trust.",
                        "Showcase fertility services for both men and women in a clear, accessible way.",
                        "Allow patients to easily book consultations using an appointment form.",
                        "Ensure the website is responsive, lightweight, and user-friendly.",
                        "Create a scalable static design for future service or content additions."
                    ]
                },
                process: {
                    title: "Process",
                    challenge: [
                        "Designing a healthcare website that is sensitive, trustworthy, and professional.",
                        "Highlighting both male and female fertility services without overwhelming the user.",
                        "Building a responsive UI to work seamlessly across desktop and mobile devices.",
                        "Integrating an appointment booking form with proper validation and submission flow."
                    ],
                },
                myContribution: {
                    title: "My Contribution",
                    myrole: [
                        "Developed the website using React and Tailwind CSS with a mobile-first approach.",
                        "Designed clear sections for fertility services, treatments, and contact information.",
                        "Implemented an appointment booking form with EmailJS integration.",
                        "Ensured accessibility and responsive layouts for all devices.",
                        "Deployed the website live on Vercel with smooth performance and fast load times."
                    ]
                },
                outcomes: {
                    title: "Outcomes",
                    results: [
                        "Launched the official Conceiva Fertility website, strengthening its digital presence.",
                        "Provided patients with an easy-to-use platform to explore fertility services.",
                        "Delivered a secure and seamless online appointment booking experience.",
                        "Improved accessibility and trustworthiness with a professional healthcare-focused UI.",
                        "Enhanced skills in building sensitive healthcare-focused static sites with form handling."
                    ]
                },
                visualgallery: {
                    title: "Visual Gallery",
                    screenShots: [{
                        title: "",
                        image: conc_1,
                    },
                    {
                        title: "",
                        image: conc_2,
                    },
                    {
                        title: "",
                        image: conc_3,
                    },
                    {
                        title: "",
                        image: conc_4,
                    },
                    {
                        title: "",
                        image: conc_5,
                    },
                    {
                        title: "",
                        image: conc_6,
                    },
                    {
                        title: "",
                        image: conc_7,
                    },
                    {
                        title: "",
                        image: conc_8,
                    },
                    {
                        title: "",
                        image: conc_9,
                    },
                    {
                        title: "",
                        image: conc_10,
                    },
                    {
                        title: "",
                        image: conc_11,
                    },
                    {
                        title: "",
                        image: conc_12,
                    },
                    {
                        title: "",
                        image: conc_13,
                    },
                    {
                        title: "",
                        image: conc_14,
                    },
                    {
                        title: "",
                        image: conc_15,
                    },
                    {
                        title: "",
                        image: conc_16,
                    },
                    {
                        title: "",
                        image: conc_17,
                    },],
                },
                navigation: {
                    demo: "https://conceivafertility.com/",
                    repo: ""
                },
                image: conceiva,
                text: " Conceiva Fertility",
            },

            //Personal Projects 
            {
                "category": "Personal",
                "tag": "Live",
                "slug": "synk-chat-app",

                "techUsed": [
                    "React",
                    "Node.js",
                    "Express",
                    "MongoDB Atlas",
                    "Socket.io",
                    "Tailwind CSS",
                    "JWT Authentication",
                    "bcrypt",
                    "DaisyUI",
                    "Context API",
                    "Cloudinary",
                    "Vercel (Frontend)",
                    "Render (Backend)"
                ],

                "header": {
                    "title": "Synk Chat Application",
                    "description": "A modern, full-stack real-time chat application inspired by WhatsApp. Built with end-to-end encryption, secure authentication, Cloudinary media storage, multi-format message support, archiving, bookmarking, theme customization, and a highly polished user experience powered by Socket.io.", "duration": "October 2025 – November 2025",
                    "role": "Full-Stack Developer (Solo Project)"
                },

                "context": {
                    "title": "Problem Statement / Intention",
                    "goals": [
                        "Create a high-performance real-time communication app with reliable message delivery and zero-lag interactions.",
                        "Implement enterprise-level security using JWT authentication, bcrypt password hashing, and custom E2EE.",
                        "Support rich media messaging—images, documents, audio—with efficient Cloudinary-based storage.",
                        "Build a modern, intuitive UI featuring alphabetical contacts, chat archiving, bookmarking, and smooth modal/image viewers.",
                        "Deliver deep visual customization with 36+ user-selectable themes.",
                        "Use Socket.io for stable real-time presence updates, message events, and live typing indicators."
                    ]
                },

                "process": {
                    "title": "Process & Challenges",
                    "challenge": [
                        "Building a robust Socket.io setup inside the Express environment to handle real-time messaging, status broadcasting, and notification events.",
                        "Implementing end-to-end encryption to ensure message payloads stay unreadable—even on the server.",
                        "Designing a secure JWT-based authentication system with bcrypt-hashed passwords for complete user protection.",
                        "Managing global state for chats, themes, user sessions, and UI interactions using Context API.",
                        "Handling multiple media formats and integrating Cloudinary to store, categorize, and deliver optimized media files.",
                        "Creating smooth UX components including modals, full-screen image viewers, and link preview cards.",
                        "Ensuring clean global state management for features like themes, modals, contact filters, and multi-chat behaviors.",
                        "Building advanced features such as alphabetical contact lists, chat archiving, and a dedicated bookmark system.",

                    ]
                },

                "myContribution": {
                    "title": "My Contribution",
                    "myrole": [
                        "Developed the full Socket.io real-time messaging layer including delivery events, read receipts, online/offline presence, and typing indicators.",
                        "Created a secure JWT authentication system with bcrypt password hashing and protected user sessions.",
                        "Implemented End-to-End Encryption (E2EE) ensuring messages are encrypted before leaving the client.",
                        "Integrated Cloudinary to store, compress, and deliver all media uploads (images, docs, audio) efficiently.",
                        "Built a polished UI with React, Tailwind CSS, DaisyUI, and custom components like modals, image viewers, and link preview cards.",
                        "Implemented advanced chat features including archive, bookmark, and quick contact filtering.",
                        "Designed alphabetical contact grouping and created dynamic navigation for A–Z contact browsing.",
                        "Developed backend REST APIs for messages, media, user profiles, link previews, archived chats, and bookmarks.",
                        "Managed global theme and state with Context API, powering 36+ customizable UI themes.",
                        "Optimized MongoDB models and queries for scalable, real-time data delivery over WebSockets."
                    ]
                },

                "outcomes": {
                    "title": "Outcomes",
                    "results": [
                        "Delivered a fully functional, secure, scalable real-time messaging system with modern features and reliable performance.",
                        "Successfully demonstrated complete ownership of a full-stack product—from backend architecture to UI engineering.",
                        "Successfully integrated Cloudinary, enabling instant cloud-based media uploads with optimized delivery.",
                        "Achieved strong security using JWT, bcrypt, and E2EE, ensuring user data privacy and message integrity.",
                        "Implemented premium UX touches including image viewer modals, link previews, theme personalization, and organized contact sorting.",
                        "Validated expertise in real-time architecture, encryption handling, cloud media storage, and production deployment workflows.",
                        "Demonstrated strong command of real-time systems, encryption, cloud services, global state, and modern UI patterns."
                    ]
                },

                visualgallery: {
                    title: "Visual Gallery",
                    screenShots: [
                        {
                            title: "",
                            image: synk_chat_1,
                        },
                        {
                            title: "",
                            image: synk_chat_2,
                        },
                        {
                            title: "",
                            image: synk_chat_3,
                        },
                        {
                            title: "",
                            image: synk_chat_4,
                        },
                        {
                            title: "",
                            image: synk_chat_5,
                        },
                        {
                            title: "",
                            image: synk_chat_6,
                        },
                        {
                            title: "",
                            image: synk_chat_7,
                        },
                        {
                            title: "",
                            image: synk_chat_8,
                        },
                        {
                            title: "",
                            image: synk_chat_9,
                        },
                        {
                            title: "",
                            image: synk_chat_10,
                        },
                        {
                            title: "",
                            image: synk_chat_11,
                        },
                        {
                            title: "",
                            image: synk_chat_12,
                        },
                        {
                            title: "",
                            image: synk_chat_13,
                        },
                        {
                            title: "",
                            image: synk_chat_14,
                        },
                        {
                            title: "",
                            image: synk_chat_15,
                        },
                        {
                            title: "",
                            image: synk_chat_16,
                        },
                        {
                            title: "",
                            image: synk_chat_17,
                        },
                        {
                            title: "",
                            image: synk_chat_18,
                        },
                        {
                            title: "",
                            image: synk_chat_19,
                        },
                        {
                            title: "",
                            image: synk_chat_20,
                        },
                        {
                            title: "",
                            image: synk_chat_21,
                        },
                        {
                            title: "",
                            image: synk_chat_22,
                        },
                        {
                            title: "",
                            image: synk_chat_23,
                        },
                        {
                            title: "",
                            image: synk_chat_24,
                        },
                        {
                            title: "",
                            image: synk_chat_25,
                        },

                    ],
                },
                navigation: {
                    demo: "https://synk-chat-five.vercel.app/",
                    repo: "https://github.com/Himanshu12866/synk_chat.git"
                },
                image: synk_chat_10,
                text: "Synk Chat App",
            },
            {
                category: "Personal",
                tag: "Live",
                slug: "dr-appointment-webapp",
                techUsed: ["React", "Node.js", "Express", "MongoDB Atlas", "Tailwind CSS", "JWT Authentication", "bcrypt", "Stripe / Razorpay Payment Gateway", "Context API"],
                header: {
                    title: "Dr. Appointment Booking Web App",
                    description: "A full-stack web application that allows patients to securely register, log in, browse available doctors, and book appointments online. The platform is built with JWT-based authentication, hashed passwords for security, and integrated payment gateway to streamline consultation payments.",
                    duration: "July 2024 – November 2024",
                    role: "Full-Stack Developer (Solo Project)",
                },
                context: {
                    title: "Problem Statement / Intention",
                    goals: [
                        "Provide a secure and user-friendly platform for patients to book doctor appointments.",
                        "Ensure secure authentication with JWT and hashed passwords.",
                        "Integrate a payment gateway for online consultation payments.",
                        "Use MongoDB cluster for scalable and reliable data storage.",
                        "Offer a smooth and intuitive appointment booking flow."
                    ]
                },
                process: {
                    title: "Process",
                    challenge: [
                        "Implementing JWT authentication and bcrypt password hashing for patient accounts.",
                        "Integrating MongoDB Atlas cluster for centralized and scalable data storage.",
                        "Designing CRUD functionality for patient appointment bookings.",
                        "Integrating a payment gateway for online consultation fees.",
                        "Building a responsive and intuitive UI to ensure seamless user experience."
                    ],
                },
                myContribution: {
                    title: "My Contribution",
                    myrole: [
                        "Developed secure login and registration system for patients.",
                        "Implemented JWT authentication and bcrypt hashing to secure patient data.",
                        "Built backend APIs using Node.js and Express for appointment and payment handling.",
                        "Integrated MongoDB Atlas cluster for patient and booking data.",
                        "Added payment gateway integration for online consultation fees.",
                        "Designed responsive frontend using React and Tailwind CSS.",
                        "Implemented CRUD functionality for booking appointments."
                    ]
                },
                outcomes: {
                    title: "Outcomes",
                    results: [
                        "Delivered a full-stack, secure, and responsive patient appointment booking platform.",
                        "Enabled patients to easily register, browse doctors, and book appointments.",
                        "Implemented robust security with JWT authentication and hashed passwords.",
                        "Integrated online payment for smooth consultation processing.",
                        "Enhanced skills in full-stack development, authentication, and payment gateway integration."
                    ]
                },
                visualgallery: {
                    title: "Visual Gallery",
                    screenShots: [
                        {
                            title: "",
                            image: dr_web_cust_1,
                        },
                        {
                            title: "",
                            image: dr_web_cust_2,
                        },
                        {
                            title: "",
                            image: dr_web_cust_3,
                        },
                        {
                            title: "",
                            image: dr_web_cust_4,
                        },
                        {
                            title: "",
                            image: dr_web_cust_5,
                        },
                        {
                            title: "",
                            image: dr_web_cust_6,
                        },
                        {
                            title: "",
                            image: dr_web_cust_7,
                        },
                        {
                            title: "",
                            image: dr_web_cust_8,
                        },
                        {
                            title: "",
                            image: dr_web_cust_9,
                        },
                        {
                            title: "",
                            image: dr_web_cust_10,
                        },
                        {
                            title: "",
                            image: dr_web_cust_11,
                        },
                        {
                            title: "",
                            image: dr_web_cust_12,
                        },
                        {
                            title: "",
                            image: dr_web_cust_13,
                        },
                        {
                            title: "",
                            image: dr_web_cust_14,
                        },
                        {
                            title: "",
                            image: dr_web_cust_15,
                        },
                        {
                            title: "",
                            image: dr_web_cust_16,
                        },
                        {
                            title: "",
                            image: dr_web_cust_17,
                        },

                    ],
                },
                navigation: {
                    demo: "https://drbookwebapp-frontend.onrender.com/",
                    repo: "https://github.com/Himanshu12866/drbookwebapp"
                },
                image: dr_web_cust_3,
                text: "Booking Web App(Patients)",
            },
            {
                category: "Personal",
                tag: "Live",
                slug: "dr-admin-doctor-control",
                techUsed: ["React", "Node.js", "Express", "MongoDB Atlas", "Tailwind CSS", "JWT Authentication", "bcrypt", "OTP Verification", "Context API"],
                header: {
                    title: "Doctor & Admin Control Panel",
                    description: "A web application built for administrators and doctors to manage hospital operations. The admin has full control over managing doctors, patients, and appointments, while doctors can log in to view and manage their schedules. The system features secure authentication, CRUD operations, and a responsive dashboard interface.",
                    duration: "July 2024 – November 2024",
                    role: "Full-Stack Developer (Solo Project)",
                },
                context: {
                    title: "Problem Statement / Intention",
                    goals: [
                        "Provide an admin panel to manage hospital operations in a structured way.",
                        "Enable the admin to add, update, or remove doctors.",
                        "Allow the admin to view and manage patient appointments.",
                        "Give doctors a dashboard to manage their appointment schedules.",
                        "Implement OTP-based login with JWT authentication and bcrypt password hashing for security.",
                        "Use MongoDB cluster for centralized, scalable data storage."
                    ]
                },
                process: {
                    title: "Process",
                    challenge: [
                        "Building a secure login system for Admin and Doctors.",
                        "Implementing OTP-based authentication along with JWT and password hashing.",
                        "Creating CRUD functionality for doctors and appointments.",
                        "Designing separate dashboards for Admin and Doctors with appropriate permissions.",
                        "Ensuring the system scales efficiently using MongoDB Atlas.",
                        "Maintaining a clean and responsive UI with Tailwind CSS."
                    ],
                },
                myContribution: {
                    title: "My Contribution",
                    myrole: [
                        "Developed login and registration system for Admin and Doctors with OTP verification.",
                        "Implemented JWT authentication and bcrypt password hashing for secure access.",
                        "Built backend APIs using Node.js and Express for doctors and appointments management.",
                        "Integrated MongoDB Atlas for storing doctors, patients, and appointment records.",
                        "Designed separate dashboards for Admin (full control) and Doctors (schedule management).",
                        "Implemented CRUD operations for doctors and appointments.",
                        "Created responsive and intuitive UI using React and Tailwind CSS."
                    ]
                },
                outcomes: {
                    title: "Outcomes",
                    results: [
                        "Delivered a role-based doctor and admin management system.",
                        "Admin can manage doctors and appointments seamlessly.",
                        "Doctors can log in and view/manage their schedules.",
                        "Implemented OTP-based login, JWT authentication, and password hashing for security.",
                        "Enhanced hospital operations through structured CRUD-based workflows.",
                        "Improved personal experience in handling authentication and dashboard-based applications."
                    ]
                },
                visualgallery: {
                    title: "Visual Gallery",
                    screenShots: [
                        {
                            title: "",
                            image: dr_web_admin_1,
                        },
                        {
                            title: "",
                            image: dr_web_admin_2,
                        },
                        {
                            title: "",
                            image: dr_web_admin_3,
                        },
                        {
                            title: "",
                            image: dr_web_admin_4,
                        },
                        {
                            title: "",
                            image: dr_web_admin_5,
                        },
                        {
                            title: "",
                            image: dr_web_admin_6,
                        },
                        {
                            title: "",
                            image: dr_web_admin_7,
                        },
                        {
                            title: "",
                            image: dr_web_admin_8,
                        },
                        {
                            title: "",
                            image: dr_web_admin_9,
                        },
                        {
                            title: "",
                            image: dr_web_admin_10,
                        },

                    ],
                },
                navigation: {
                    demo: "https://drbookwebapp-admin.onrender.com/",
                    repo: ""
                },
                image: dr_web_admin_1,
                text: "Booking Web App(Admin)",
            }
        ],
    },

    // Project page data and case study pages data completed
];
export default portfolioData;
